/** @jsx jsx */
import PropTypes from "prop-types"
import { Fragment } from "react"
import { jsx } from "theme-ui"
import { graphql } from "gatsby"
import { MDXRenderer } from "gatsby-plugin-mdx"
import { MDXProvider } from "@mdx-js/react"

import Layout from "components/layout"
import mdxComponents from "components/mdx"

import Arrow from "components/svgs/arrow"
import Kite from "components/svgs/kite"
import Twist from "components/svgs/twist"

const FullTemplate = ({ data }) => {
  return (
    <Layout
      pageTitle={data.mdx.frontmatter.title}
      desription={data.mdx.frontmatter.description}
    >
      {data.mdx ? (
        <Fragment>
          <MDXProvider components={mdxComponents}>
            <MDXRenderer>{data.mdx.body}</MDXRenderer>
          </MDXProvider>
          <Arrow
            sx={{
              position: "absolute",
              left: -5,
              top: "25%",
              height: "auto",
              width: "16rem",
              display: ["none", "none", "none", "block"],
            }}
          />
          <Kite
            flipX
            sx={{
              position: "absolute",
              right: 3,
              top: "50%",
              height: "auto",
              width: "10rem",
              display: ["none", "none", "none", "block"],
            }}
          />
          <Twist
            flipX
            flipY
            sx={{
              position: "absolute",
              left: -4,
              top: "75%",
              height: "auto",
              width: "16rem",
              display: ["none", "none", "none", "block"],
            }}
          />
        </Fragment>
      ) : (
        <div>This page hasn&apos;t been translated yet</div>
      )}
    </Layout>
  )
}

FullTemplate.propTypes = {
  data: PropTypes.shape({
    mdx: PropTypes.shape({
      frontmatter: PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
      }),
      body: PropTypes.any,
    }),
  }),
}

export default FullTemplate

export const query = graphql`
  query($locale: String!, $slug: String!) {
    site {
      siteMetadata {
        title
        shortTitle
        description
      }
    }
    mdx(
      fields: { locale: { eq: $locale } }
      frontmatter: { slug: { eq: $slug } }
    ) {
      frontmatter {
        slug
        title
        description
      }
      body
    }
  }
`
